export enum GCmembershipTypes {

    GET_GCMEMBERSHIP_LIST_REQUEST = 'GET_GCMEMBERSHIP_LIST_REQUEST',
    GET_GCMEMBERSHIP_LIST_REQUEST_SUCCESS = 'GET_GCMEMBERSHIP_LIST_REQUEST_SUCCESS',
    GET_GCMEMBERSHIP_LIST_REQUEST_FAILURE = 'GET_GCMEMBERSHIP_LIST_REQUEST_FAILURE',

}